import {IntermediatePart} from "../../intermediatePart";

export default class Ceiling extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'walls_ceiling';
    this.partName = 'Ceiling';
    this.translateId = "visualizer.kitchen.walls.walls_ceiling";
    this.isStoneFeature = true;
  }
}
